export const grayScale = {
  name: 'gray scale',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;

const vec3 luma_weights = vec3(0.299, 0.587, 0.114);

void main() {
    vec4 color = texture2D(u_image, v_texCoord);
    float intensity = dot(color.rgb, luma_weights);
    vec3 gray_color = vec3(intensity);
    gl_FragColor = vec4(gray_color, color.a);
}`,
  uniforms: [],
};
